import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

import { popoverShadow } from "@styles/emotion-styles/baseStyles";
import * as colors from "@styles/emotion-styles/colors";
import * as dimensions from "@styles/emotion-styles/dimensions";

export const ssoContainer = css`
  height: 100vh;
  display: flex;
  padding: 1rem;
  justify-content: center;
  flex-direction: column;
`;

export const titleText = (theme: Theme) => css`
  color: ${theme.text.body};
  margin-left: 2rem;
  font-size: 2rem;
  &:not(:last-child) {
    margin-bottom: 0;
  }

  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    margin-left: 0;
    width: 100%;
  }
`;

export const enterEmailText = (theme: Theme) => css`
  font-size: 1rem;
  color: ${theme.text.body};
  border-radius: 0.5rem 0.5rem 0 0;
  background-color: ${theme.surface.level2};
  text-align: center;
  padding: 1rem;
`;

export const submitButton = css`
  display: block;
  margin-top: 1rem;
  margin-left: auto;
  margin-right: auto;
  width: 60%;
`;

export const loginLink = css`
  display: block;
  margin-top: 1rem;
  text-align: center;
`;

export const builderText = css`
  width: 25rem;
  margin-top: 5rem;

  font-weight: ${typography.weightBold};
  font-size: 4rem;
  line-height: 6.25rem;

  display: flex;
  align-items: center;
`;

export const rightColumn = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const formBox = (theme: Theme) => css`
  ${popoverShadow(theme)}
  border-radius: ${dimensions.borderRadius};
  margin: 2rem 0;
`;

export const ds4FormBox = () => css`
  box-shadow: none;
  margin: 2rem 0;
`;

export const form = css`
  padding: 2rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    padding: 1rem;
  }
`;

export const formMeta = css`
  display: flex;
  margin-bottom: 0.5rem;
  titleText:not(:last-child) {
    margin-bottom: 0.25rem;
  }
`;

export const formMetaDS4 = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const flagContainer = css`
  display: flex;
  align-items: center;
  margin-left: 1rem;

  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    margin-left: 0;
    margin-top: 2rem;
    width: 100%;
    justify-content: center;
  }
`;

export const flagDiv = css`
  background-color: ${colors.grey.lightFamily.light};
  padding: 0.5rem;
  border-radius: 1rem;
  margin-left: 1rem;
  cursor: pointer;

  > img {
    width: 2.5rem;
    height: 100%;
    border-radius: 0.5rem;
  }
`;

export const highlightedFlag = (theme: Theme) => css`
  ${popoverShadow(theme)}
  background-color: ${colors.grey.lightFamily.dark};
`;

export const checkCircle = (theme: Theme) => css`
  font-size: 1.5rem;
  position: absolute;

  svg:first-of-type {
    background-color: ${theme.success.textBase};
    border-radius: 50%;
  }

  svg.svg-inline--fa {
    top: -2rem;
    right: 1rem;
  }
`;
